import { useEffect, useState } from 'react';
import { runAssetsApi } from '../../lib/runAssets';

/**
 * Lightweight count of downloaded screenshots, used to drive the Phase 5
 * (AI Validation) "Game-Help Screenshots" banner status. Refetches whenever
 * the active run changes; the dashboard never invalidates this aggressively
 * because the download is a manual user action.
 */
export function useImagesCount(runId: string | null): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!runId) return;
    let alive = true;
    runAssetsApi
      .listImages(runId)
      .then((data) => {
        if (alive) setCount(data.items.length);
      })
      .catch(() => {
        if (alive) setCount(0);
      });
    return () => {
      alive = false;
    };
  }, [runId]);
  return count;
}

/**
 * Whether the per-image vision analysis log exists. Used by the rail to mark
 * the Analyze Images sub-step as completed without needing a phase update.
 */
export function useImagesAnalysisExists(runId: string | null): boolean {
  const [exists, setExists] = useState(false);
  useEffect(() => {
    if (!runId) return;
    let alive = true;
    runAssetsApi
      .loadImagesAnalysis(runId)
      .then((data) => {
        if (alive) setExists(data.exists);
      })
      .catch(() => {
        if (alive) setExists(false);
      });
    return () => {
      alive = false;
    };
  }, [runId]);
  return exists;
}
